<template>
	<div class="study">
		<publicHeader></publicHeader>
		<div class="help_header bg_gray">
			<div class="w1200 flex">
				<div class="flex">
					<img :src="public.top_logo" class="study_header_logo" />
					<div class="f20px study_header_name">·&nbsp;&nbsp;&nbsp;&nbsp;帮助中心</div>
				</div>
			</div>
		</div>
		<div class="help_screen tc">
			<div class="w1200">
				<p class="f26px cl_white help_screen_top">欢迎使用趣学云课堂帮助中心</p>
				<div class="study_header_r bg_white">
					<input type="text" v-model="searchText" placeholder="请输入问题关键词" class="f16px" />
					<div class="study_header_btn cl_white f18px" @click="searchBtn"><img src="../../../static/search_white.png" /><span>搜一搜</span></div>
				</div>
			</div>
		</div>
		<div class="help_cont bg_gray">
			<div class="w1200">
				<div class="help_cont_title f20px">帮助中心</div>
				<div class="help_list_cont mat15">
					<div class="help_list bg_white" v-for="(item,index) in list" :key="index">
						<div class="help_list_title flex">
							<span class="f18px clip">{{item.name}}</span>
							<router-link :to="{ path: '/help_list', query: { id: item.id }}" class="cl_violet">更多 →</router-link>
						</div>
						<div class="help_list_btm f16px">
							<router-link :to="{ path: '/help_details', query: { id: item.id }}" v-for="(item,index) in item.article_data" :key="index" class="cl_gray clip block mat15">{{item.name}}</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
		<vfooter @child-event="publicEvent"></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'help',
		components: {
			publicHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				public: {},
				searchText: "",
				list: [],
			}
		},
		mounted() {
			this.getList();
		},
		created() {
			
		},
		methods: {
			publicEvent (data) {
				this.public = data;
			},
			getList () {
				this.$get("/api/article/get_article_cate_data",{})
				.then(res => {
					this.list = res.data;
				});
			},
			searchBtn () {
				if (this.searchText != "") {
					this.$router.push({path:'/help_list',query: {name:this.searchText}})
				}
			},
		},
	}
</script>

<style>
</style>
